import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "q-pa-md" }
const _hoisted_2 = { style: {"width":"100%"} }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { style: {"font-family":"'PT Sans Narrow', sans-serif","font-size":"0.8em"} }
const _hoisted_5 = {
  class: "row",
  style: {"width":"150px","margin-top":"5px","margin-bottom":"5px","display":"flex","justify-content":"flex-start"}
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"'PT Sans Narrow', sans-serif","font-size":"0.9em"} }, "Arata si cele inactive", -1)
const _hoisted_7 = { style: {"font-family":"'Nunito Sans', sans-serif","font-size":"0.8em"} }
const _hoisted_8 = { style: {"font-family":"'Nunito Sans', sans-serif","font-size":"0.8em"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_toggle = _resolveComponent("q-toggle")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_tr = _resolveComponent("q-tr")!
  const _component_q_table = _resolveComponent("q-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_table, {
      dense: "",
      "rows-per-page-options": [0],
      rows: _ctx.tableDataNomUsers,
      columns: _ctx.columns,
      "visible-columns": _ctx.visibleColumns,
      "row-key": "marca",
      filter: _ctx.filterNomUsers,
      loading: _ctx.loadingData,
      pagination: _ctx.myPagination
    }, {
      top: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.title), 1),
            _createVNode(_component_q_space),
            _createVNode(_component_q_input, {
              dense: "",
              debounce: "300",
              color: "primary",
              modelValue: _ctx.filterNomUsers,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterNomUsers) = $event))
            }, {
              append: _withCtx(() => [
                _createVNode(_component_q_icon, { name: "search" })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_q_space),
            _createVNode(_component_q_toggle, {
              dense: "",
              modelValue: _ctx.celeInactive,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.celeInactive) = $event)),
              "checked-icon": "lock",
              debounce: "300",
              color: "primary",
              "unchecked-icon": "lock_open",
              "false-value": "Nu",
              "true-value": "Da",
              onClick: _ctx.changeStatus
            }, null, 8, ["modelValue", "onClick"])
          ])
        ])
      ]),
      body: _withCtx((props) => [
        _createVNode(_component_q_tr, {
          props: props,
          onClick: ($event: any) => (_ctx.selectHandler(props.row)),
          style: _normalizeStyle(props.row.is_activ == 'n' ? 'background-color: #dddddd' : '')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_td, {
              key: "nume_prenume",
              props: props,
              sortable: true
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_7, _toDisplayString(props.row.nume_prenume), 1)
              ]),
              _: 2
            }, 1032, ["props"]),
            _createVNode(_component_q_td, {
              key: "organization_unit_descriere",
              props: props,
              sortable: true
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_8, _toDisplayString(props.row.organization_unit_descriere), 1)
              ]),
              _: 2
            }, 1032, ["props"])
          ]),
          _: 2
        }, 1032, ["props", "onClick", "style"])
      ]),
      _: 1
    }, 8, ["rows", "columns", "visible-columns", "filter", "loading", "pagination"])
  ]))
}